module.exports = __webpack_public_path__ + "img/logo.fffb5ca4.png";